/** Canonicalizes an org-identifier argument so a query key and its fetch call
 * never fork on `''` vs `null` vs `undefined`. All three collapse to the same
 * `undefined` ("no org"); a real UUID string passes through unchanged. */
export function normalizeOrgUUID(orgUUID?: string | null): string | undefined {
  return orgUUID ? orgUUID : undefined;
}
